import {
  isWithinInterval,
  subDays,
  subMinutes,
  format as dateFormat,
  isSameDay,
  isSameYear,
  subHours,
  differenceInMinutes,
  isAfter,
  differenceInHours,
  startOfDay,
  addSeconds
} from 'date-fns'

// checks for time intervals
export const withinTimeInterval = time => {
  // 0 - less than 1 day
  // 1 - more than 1 day but less than 1 week
  // 2 - more than 1 week but less than 1 year
  // 3 - more than 1 year

  if (isSameDay(new Date(time), new Date(Date.now()))) {
    return 0
  } else if (
    isWithinInterval(new Date(time), {
      start: subDays(new Date(), 7),
      end: new Date(Date.now())
    })
  ) {
    return 1
  } else if (
    isWithinInterval(new Date(time), {
      start: subDays(new Date(), 365),
      end: subDays(new Date(), 7)
    })
  ) {
    return 2
  } else if (new Date(Date.now()) - new Date(time)) {
    return 3
  } else {
    return null
  }
}

// formats the date according to given format i.e d MMM, yyyy
export const formatDate = (date, format) => {
  const asDate = date ? new Date(date) : new Date()
  return dateFormat(asDate, format)
}

// Gets shortened date form, including year if different from current
export const formatDateTask = (date, now = Date.now()) => {
  const testDate = new Date(date)
  const current = new Date(now)

  const suffix = isSameYear(testDate, current) ? '' : ', yyyy'

  return dateFormat(testDate, `MMM d${suffix}`)
}

// Formats time as required for conversations v1
export const formatMessageTimeSince = (date, now = Date.now()) => {
  const nowDate = new Date(now)
  if (!date) {
    return ''
  }

  const asDate = new Date(date)
  if (!isAfter(asDate, startOfDay(nowDate)))
    // Before the start of yesterday, default
    return dateFormat(asDate, 'MMM d, h:mm aaa')

  // On this day
  const hourDiff = differenceInHours(nowDate, asDate)

  if (hourDiff < 24) {
    return dateFormat(asDate, 'h:mm aaa')
  }

  if (hourDiff === 24) {
    return `Yesterday, ${dateFormat(asDate, 'h:mm aaa')}`
  }

  return dateFormat(asDate, 'MMM d, h:mm aaa')
}

// Formats time as required for conversations v2
export const formatTimeSince = (
  date,
  now = Date.now(),
  timelineMode = false
) => {
  const nowDate = new Date(now)
  if (!date) {
    return ''
  }

  const asDate = new Date(date)

  // In the last 2 minutes
  if (
    isWithinInterval(asDate, {
      start: subMinutes(nowDate, 2),
      //sometimes server has some seconds ahead from our current time. super weird but this prevents 0 hours ago bug.
      end: addSeconds(nowDate, 30)
    })
  ) {
    return 'Just now'
  }

  // In the last hour
  if (isWithinInterval(asDate, { start: subHours(nowDate, 1), end: nowDate })) {
    // Format difference as x mins
    const minsDiff = differenceInMinutes(nowDate, asDate)

    if (minsDiff === 60) {
      return timelineMode ? '1 hr ago' : '1 hr'
    }

    return timelineMode ? `${minsDiff} mins ago` : `${minsDiff} mins`
  }

  // On this day
  if (isAfter(asDate, startOfDay(nowDate))) {
    // Format difference as x hr(s)
    const hourDiff = differenceInHours(nowDate, asDate)

    if (hourDiff === 24) {
      return timelineMode
        ? `Yesterday, ${dateFormat(asDate, 'h:mm aaa')}`
        : 'Yesterday'
    }

    return timelineMode
      ? `${hourDiff} hr${hourDiff === 1 ? '' : 's'} ago`
      : `${hourDiff} hr${hourDiff === 1 ? '' : 's'}`
  }

  // After the start of yesterday
  if (isAfter(asDate, startOfDay(subDays(nowDate, 1)))) {
    return timelineMode
      ? `Yesterday, ${dateFormat(asDate, 'h:mm aaa')}`
      : 'Yesterday'
  }

  // Before the start of yesterday, default
  return timelineMode
    ? dateFormat(asDate, 'MMM d, h:mm aaa')
    : dateFormat(asDate, 'MMM d, yyyy')
}
